import { useUpdates } from 'providers/UpdatesProvider/UpdatesProvider'
import Styles from './UpdateModalsWidget.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Close } from 'blaze-ui/icons'
import { Pressable } from '@react-aria/interactions'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'

export const UpdateModalsWidget = () => {
  const { pendingUpdates, displayLatestUpdate, markModalAsViewed } = useUpdates()
  const newestUpdate = pendingUpdates[0]
  const { isMobile, isIOSNative } = useResponsiveDesign()
  const isAPMobileWeb = useAPMobileWeb()

  if (!newestUpdate || isIOSNative || isAPMobileWeb) {
    return null
  }

  const handleCloseWidget = () => {
    pendingUpdates.forEach((modal) => markModalAsViewed(modal.id))
  }

  return (
    <Pressable onPress={displayLatestUpdate}>
      <div className={Styles.container}>
        <div className={Styles.header}>
          <Text variant="label">What's New</Text>
          <div className={Styles.iconContainer}>
            <IconButton onPress={handleCloseWidget} icon={Close} size="xs" variant="tertiary" />
          </div>
        </div>
        <Text variant={isMobile ? 'largeList' : 'smallList'}>{newestUpdate.title}</Text>
      </div>
    </Pressable>
  )
}
